export default class AppService {
	constructor() {
	
	}

	extractMessageFromErrorObject(error) {
		let message = 'Unknown error occurred';
		if (error.response !== undefined && error.response.data !== undefined && error.response.data.Message !== undefined) {
			message = error.response.data.Message;
		} else if (error.message !== undefined) {
			message = error.message;
		} else if (typeof(error) === "string") {
			return error;
		}
		return message;
	}
}




// WEBPACK FOOTER //
// ./src/service/app.js